function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.025 134.337C294.743 186.308 216.816 207.634 139.971 204.742C56.7507 201.646 40.8437 143.569 88.9158 88.267C128.947 42.2553 185.031 13.5382 248.864 14.0056C333.195 14.6191 351.412 95.0738 327.025 134.337Z",
  fill: "#EFF6FE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M294 56.0049V99H275.595V57.5372C275.211 39.2076 258.106 24.3258 237.485 24.3258C216.865 24.3258 199.789 39.2076 199.375 57.5372V99H181V56.0049C180.941 29.6891 206.466 8 237.515 8C268.564 8 294.059 29.6891 294 56.0049Z",
  fill: "#F8D14E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M173.674 65H302.326C311.537 65 319 72.5201 319 81.8008V144.199C319 153.48 311.537 161 302.326 161H173.674C164.463 161 157 153.48 157 144.199V81.8008C157 72.5201 164.463 65 173.674 65Z",
  fill: "#B4DCDE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M204 88.4449V94.5551C204 94.7569 204 94.9587 203.971 95.1604C203.657 99.5414 199.824 103 195.162 103H185.838C181.176 103 177.343 99.5414 177.029 95.1604C177 94.9587 177 94.7569 177 94.5551V88.4449C177 88.2431 177 88.0413 177.029 87.8396C177.343 83.4586 181.176 80 185.838 80H195.162C199.824 80 203.657 83.4586 203.971 87.8396C203.971 88.0413 204 88.2431 204 88.4449Z",
  fill: "#F8D14E",
  stroke: "#EC6626",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M190 99V84",
  stroke: "#EC6626",
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M198 91H181",
  stroke: "#EC6626",
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M195 88H185V95H195V88Z",
  fill: "#F8D14E",
  stroke: "#EC6626",
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M177 88H181V95H177",
  stroke: "#EC6626",
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M204 95H198V88H204",
  stroke: "#EC6626",
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M195 80V84H185V80",
  stroke: "#EC6626",
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M185 103V99H195V103",
  stroke: "#EC6626",
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M169.41 120H194.59C196.465 120 198 121.322 198 122.939V123.061C198 124.678 196.465 126 194.59 126H169.41C167.535 126 166 124.678 166 123.061V122.939C166 121.322 167.535 120 169.41 120Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M206.517 120H232.483C234.417 120 236 121.322 236 122.939V123.061C236 124.678 234.417 126 232.483 126H206.517C204.583 126 203 124.678 203 123.061V122.939C203 121.322 204.583 120 206.517 120Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M242.517 120H268.483C270.417 120 272 121.322 272 122.939V123.061C272 124.678 270.417 126 268.483 126H242.517C240.583 126 239 124.678 239 123.061V122.939C239 121.322 240.583 120 242.517 120Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M277.623 120H304.377C306.369 120 308 121.322 308 122.939V123.061C308 124.678 306.369 126 304.377 126H277.623C275.631 126 274 124.678 274 123.061V122.939C274 121.322 275.631 120 277.623 120Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M167.74 137H191.289C192.246 137 193 137.653 193 138.427V138.573C193 139.371 192.217 140 191.289 140H167.711C166.754 140 166 139.347 166 138.573V138.427C166 137.653 166.783 137 167.74 137Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M167.758 143H232.243C233.226 143 234 144.089 234 145.379V145.621C234 146.952 233.196 148 232.243 148H167.758C166.775 148 166.001 146.911 166.001 145.621V145.379C165.971 144.048 166.775 143 167.758 143Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M132.5 242C164.806 242 191 239.486 191 236.5C191 233.514 164.806 231 132.5 231C100.194 231 74.0002 233.514 74.0002 236.5C73.9129 239.611 100.107 242 132.5 242Z",
  fill: "#EAEAEA"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M219.191 217.356C230.347 217.356 239.391 208.284 239.391 197.093C239.391 185.902 230.347 176.83 219.191 176.83C208.034 176.83 198.99 185.902 198.99 197.093C198.99 208.284 208.034 217.356 219.191 217.356Z",
  fill: "white",
  stroke: "#DDEAEB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M233.635 182.897L204.627 211.112",
  stroke: "#DDEAEB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M292.945 182.603C303.063 182.603 311.266 174.375 311.266 164.225C311.266 154.075 303.063 145.847 292.945 145.847C282.826 145.847 274.624 154.075 274.624 164.225C274.624 174.375 282.826 182.603 292.945 182.603Z",
  fill: "white",
  stroke: "#DDEAEB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M284.871 163.018C285.746 163.018 286.456 162.306 286.456 161.427C286.456 160.549 285.746 159.837 284.871 159.837C283.995 159.837 283.285 160.549 283.285 161.427C283.285 162.306 283.995 163.018 284.871 163.018Z",
  fill: "#DDEAEB"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M298.993 159.778C299.869 159.778 300.579 159.066 300.579 158.187C300.579 157.309 299.869 156.597 298.993 156.597C298.118 156.597 297.408 157.309 297.408 158.187C297.408 159.066 298.118 159.778 298.993 159.778Z",
  fill: "#DDEAEB"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M287.748 175.329C290.831 170.764 296.909 169.379 301.665 172.148",
  stroke: "#DDEAEB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5592 108.414C79.1644 108.414 82.8977 104.669 82.8977 100.049C82.8977 95.4299 79.1644 91.6851 74.5592 91.6851C69.954 91.6851 66.2207 95.4299 66.2207 100.049C66.2207 104.669 69.954 108.414 74.5592 108.414Z",
  fill: "white",
  stroke: "#DDEAEB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M71.4418 99.0658C71.7396 98.8145 71.7695 98.3585 71.5086 98.0473C71.2476 97.7361 70.7946 97.6875 70.4968 97.9388C70.199 98.1901 70.1691 98.6461 70.43 98.9573C70.691 99.2685 71.1439 99.3171 71.4418 99.0658Z",
  fill: "#DDEAEB"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M77.9725 98.0863C78.2704 97.835 78.3003 97.379 78.0393 97.0678C77.7784 96.7566 77.3254 96.708 77.0276 96.9593C76.7297 97.2106 76.6998 97.6666 76.9608 97.9778C77.2217 98.289 77.6747 98.3376 77.9725 98.0863Z",
  fill: "#DDEAEB"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M71.8286 104.909C73.3847 102.936 76.2034 102.494 78.2586 103.937",
  stroke: "#DDEAEB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M154.361 40.4389C160.491 40.4389 165.46 35.4546 165.46 29.3061C165.46 23.1577 160.491 18.1733 154.361 18.1733C148.232 18.1733 143.263 23.1577 143.263 29.3061C143.263 35.4546 148.232 40.4389 154.361 40.4389Z",
  fill: "white",
  stroke: "#DDEAEB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M162.289 21.5012L146.346 37.0224",
  stroke: "#DDEAEB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.984 217.226C102.177 222.435 107.556 232.267 105.56 235.996C104.538 236.335 93 215.284 93 215.284C94.3388 214.113 96.2618 211.832 98.7933 211L100.984 217.226Z",
  fill: "#29394D"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113.721 126.578C113.721 126.578 129.069 158.488 120.287 182.01C113.001 201.456 103.787 218.994 103.787 218.994C103.787 218.994 100.101 219.317 99.5249 215.064C99.5249 215.064 105.514 183.066 108.279 179.371C114.153 171.51 94.0825 129.834 95.0328 121.68C95.983 113.527 113.721 126.578 113.721 126.578Z",
  fill: "#997948"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173 125.5C173 137.919 162.471 148 149.5 148C136.529 148 126 137.919 126 125.5C126 113.081 136.529 103 149.5 103C162.471 103 173 113.081 173 125.5ZM149.5 112.468C141.992 112.468 135.888 118.282 135.888 125.5C135.888 132.718 141.962 138.532 149.5 138.532C157.008 138.532 163.112 132.718 163.112 125.5C163.112 118.312 157.008 112.497 149.5 112.468Z",
  fill: "#F8D14E"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M155 139H144V236H155V139Z",
  fill: "#F8D14E"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M178 226H155V236H178V226Z",
  fill: "#F8D14E"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M166 215H155V220H166V215Z",
  fill: "#F8D14E"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M170 199H155V205H170V199Z",
  fill: "#F8D14E"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M175 202H155V210H175V202Z",
  fill: "#F8D14E"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.844 126.279C86.844 126.279 84.5104 164.011 87.6038 189.018C90.6972 214.026 92.6781 227.279 92.6781 227.279C92.6781 227.279 93.4922 230.747 97.8067 227.837C97.8067 227.837 100.005 193.074 100.412 182.906C100.629 177.411 102.42 144.41 102.42 144.41C102.42 144.41 105.947 142.236 104.753 128.248C104.075 120.02 86.844 126.279 86.844 126.279Z",
  fill: "#AE8A4F"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M136.048 87C140.464 90.7584 144.909 94.6017 149.353 98.4731C151.213 100.112 153.072 101.723 154.902 103.334C154.989 103.645 155.018 103.955 154.989 104.294C154.757 106.81 150.748 108.336 149.15 108.957C145.199 110.54 139.883 113.111 132.33 117.209C132.737 119.583 132.853 122.013 132.65 124.443C132.446 127.043 132.243 129.049 130.819 129.756C129.803 130.264 128.583 129.869 127.827 129.558C127.188 128.371 126.694 127.099 126.375 125.771C125.707 122.776 125.939 119.667 127.014 116.785C130.674 110.907 134.683 107.855 137.85 106.103C141.336 104.181 145.751 102.797 145.722 102.797C145.693 102.797 143.979 103.447 142.41 104.04L130.268 95.7603L136.048 87Z",
  fill: "#F8B578"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M97.6078 228.534C102.685 229.938 113.028 233 114 237.748C113.46 238.759 96.0955 236.4 96.0955 236.4C96.0955 236.4 91.8287 235.501 93.314 228L97.6078 228.534Z",
  fill: "#29394D"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M129.094 99L137 89.1505C137 89.1505 127.624 79.4165 124.24 78.0878C124.018 78.0012 123.768 77.9723 123.519 78.0301C121.272 78.7233 121.965 87.764 122.77 94.5229L129.094 99Z",
  fill: "#F8D14E"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M126.832 73.8392C127.213 72.8728 127.653 71.9365 128.122 71.0305C128.59 70.1547 128.854 69.7319 129.001 69.5205C130.055 67.7991 133.337 69.3997 134.04 66.4099C134.04 66.4099 135.563 56.5043 134.772 52.3366L125.954 50.1018C122.584 49.7394 120.094 50.0112 118.629 56.6553C119.01 58.2257 119.244 59.7961 119.303 61.4269C119.449 65.8361 119.83 68.0407 118.57 69.8829C118.131 70.5171 116.93 71.9667 114 72.5103C116.315 75.0472 119.098 77.131 122.145 78.6108C123.287 79.1544 124.459 79.6074 125.661 80C126.041 77.9162 126.452 75.8928 126.832 73.8392Z",
  fill: "#F6BD83"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M123.611 57.3091L124.315 59.4496L125.172 59.5309C125.539 57.4717 125.601 53.6512 130.13 53.6241C133.374 53.6512 138.761 53.4615 139.648 50.1829C140.597 46.6334 139.832 45.0076 134.813 42C131.569 45.6579 127.376 42.7316 121.01 43.8154C112.869 45.1702 113.604 53.4073 114.583 55.3582C116.205 58.3387 116.236 61.265 116.419 64.1372C120.031 66.7655 122.173 62.6469 121.102 61.6173C117.368 57.851 122.938 55.3582 123.611 57.3091Z",
  fill: "#424A59"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86 128.468C87.702 118.653 90.079 108.987 93.0429 99.4975C97.9142 84.0367 101.289 79.0112 106.072 75.5525C109.242 73.2762 112.851 71.739 116.666 71C117.311 72.3303 119.072 75.3456 122.594 77.0601C123.591 77.5331 124.677 77.8879 125.763 78.0652C126.937 80.578 127.289 83.4159 126.761 86.1356C125.587 92.7278 124.032 99.2314 122.124 105.617C119.718 113.628 116.754 121.432 113.262 129L86 128.468Z",
  fill: "#F8D14E"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M101 92.8462L111.028 88L113.55 107.158C119.247 110.446 123.044 114.782 132.983 116.652C134.853 117.276 136.544 118.296 137.909 119.656C138.917 120.648 141.528 123.284 140.905 126.43C140.786 127.025 140.49 128.499 139.481 128.895C136.9 129.916 131.797 123.171 130.788 121.839C126.842 121.385 121.679 119.826 115.597 117.871C111.295 116.482 107.794 114.81 105.332 112.146L101 92.8462Z",
  fill: "#F7BE85"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M296 85.7825C296 79.2753 290.851 74 284.5 74C278.149 74 273 79.2753 273 85.7825C273 90.1417 275.343 94.1218 279.074 96.1751V109H289.926V96.1751C293.657 94.1218 296 90.1101 296 85.7825Z",
  fill: "#4EBBB9"
});

var SvgUnavailablePayment = function SvgUnavailablePayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 250,
    viewBox: "0 0 400 250",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnavailablePayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unavailable_payment.e0d5c088.svg";
export { ForwardRef as ReactComponent };